var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "M13.125 11.875a.625.625 0 0 1-.625.625h-5a.625.625 0 1 1 0-1.25h5a.625.625 0 0 1 .625.625M12.5 8.75h-5a.625.625 0 0 0 0 1.25h5a.625.625 0 1 0 0-1.25m4.375-5v13.125a1.25 1.25 0 0 1-1.25 1.25H4.375a1.25 1.25 0 0 1-1.25-1.25V3.75a1.25 1.25 0 0 1 1.25-1.25h2.833a3.744 3.744 0 0 1 5.584 0h2.833a1.25 1.25 0 0 1 1.25 1.25M7.5 5h5a2.5 2.5 0 0 0-5 0m8.125-1.25h-2.09c.142.401.215.824.215 1.25v.625a.625.625 0 0 1-.625.625h-6.25a.625.625 0 0 1-.625-.625V5c0-.426.073-.849.215-1.25h-2.09v13.125h11.25z"
  })));
};
export default SvgFile;